import { zBsRegSettings } from "src/businessServices/services/bsRegistration/bsRegistration.types";
import { zUid } from "src/types/zUid";
import { z } from "zod";

export const zRegInfo = z.object({
  settingsId: zUid,
  objectId: zUid,
  settings: zBsRegSettings,
});

export type ZRegInfo = z.infer<typeof zRegInfo>;

export const zRegSuccessMessage = z.object({
  message: z.string(),
  success: z.boolean(),
});

export type ZRegSuccessMessage = z.infer<typeof zRegSuccessMessage>;
